import { Component, OnInit, OnDestroy, QueryList, ViewChildren, Input, ContentChildren, forwardRef, Output, EventEmitter } from "@angular/core";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { UploadFileComponent } from "../upload-file/upload-file.component";
import { Subscription, merge } from "rxjs";
import { startWith } from "rxjs/operators";

@Component({
  selector: "app-upload-file-queue",
  templateUrl: "./upload-file-queue.component.html",
  styleUrls: ["./upload-file-queue.component.css"]
})
export class UploadFileQueueComponent implements OnDestroy {
  @ContentChildren(forwardRef(() => UploadFileComponent)) fileUploads: QueryList<UploadFileComponent>;

  /** Subscription to remove changes in files. */
  private _fileRemoveSubscription: Subscription | null;

  /** Subscription to changes in the files. */
  private _changeSubscription: Subscription;

  /** Combined stream of all of the file upload remove change events. */
  get fileUploadRemoveEvents() {
    return merge(...this.fileUploads.map(fileUpload => fileUpload.removeEvent));
  }

  public files: Array<File> = [];

  /* Http request input bindings */
  @Input()
  httpUrl: string;

  @Input()
  httpRequestHeaders:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      } = new HttpHeaders().set("Content-Type", "multipart/form-data");

  @Input()
  httpRequestParams:
    | HttpParams
    | {
        [param: string]: string | string[];
      } = new HttpParams();

  @Input()
  fileAlias: string = "file";

  @Output() addFileEvent = new EventEmitter<File>();

  ngAfterViewInit() {
    // When the list changes, re-subscribe
    this._changeSubscription = this.fileUploads.changes.pipe(startWith(null)).subscribe(() => {
      if (this._fileRemoveSubscription) {
        this._fileRemoveSubscription.unsubscribe();
      }
      this._listenTofileRemoved();
    });
  }

  private _listenTofileRemoved(): void {
    this._fileRemoveSubscription = this.fileUploadRemoveEvents.subscribe((event: UploadFileComponent) => {
      this.files.splice(event.id, 1);
    });
  }

  addFile(file: File) {
    this.files.push(file);
    this.addFileEvent.emit(file);
  }

  public uploadAll() {
    this.fileUploads.forEach(fileUpload => {
      fileUpload.upload();
    });
  }

  public removeAll() {
    this.files.splice(0, this.files.length);
  }

  public remove(file: File) {
    this.files = this.files.filter(x => {
      return x.size != file.size && x.name != file.name && file.lastModified != x.lastModified;
    });
  }

  ngOnDestroy() {
    if (this.files) {
      this.removeAll();
    }
  }
}
